'use strict';

export class SignupService {
	static $inject = ['mx.SolutionBuilderAgent.Http'];

	constructor(http) {
		this.http = http;
	}

	async signupUser(email) {
		this._email = email;
		return this.http.post('/api/signupuser', JSON.stringify(email));
	}

	async resendEmail() {
		return this.signupUser(this._email);
	}
}
